export const VARIANT_DEFAULT = 'default';
export const VARIANT_ERROR = 'error';
export const VARIANT_SUCCESS = 'success';



// WEBPACK FOOTER //
// ./src/components/markup/popup/form/notification/const.js